export default __webpack_public_path__ + "static/media/CommunicationsStyles.48300b4b.png";